import React, { useContext } from 'react'
import TopNavigation from './TopNavigation'
import Logo from './Logo'
import { CarOrderingContext } from "../../CarOrdering"
import classNames from "classnames"

export default function Header() {
  const {
    isMenuOpen,
    setIsMenuOpen,
    currentStep,
  } = useContext(CarOrderingContext)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header>
      <Logo/>
      <TopNavigation/>
      <div className='top-title'>
        <span>{currentStep.id}.</span>
        &nbsp;
        {currentStep.title}
      </div>
      <div
        id='config-navigation-toggle'
        onClick={toggleMenu}
        className={classNames('config-navigation__toggle-icon', {
          open: isMenuOpen
        })}
      >
        <div className='open'/>
      </div>
    </header>
  )
}
